import { useEffect } from 'react';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { DashboardContent } from '@starjack/widgets/dashboard';
import { Permission } from '@/models/user';
import { Environment } from '@starjack/entities/environment';
import { PageWithLayout } from '@/models/page';

const Page: PageWithLayout = () => {
    useEffect(() => {
        document.title = 'Dashboard - B2B | Starjack Admin';
    }, []);

    return <DashboardContent environments={[Environment.B2B]} />;
};

Page.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Page.isProtected = true;
Page.permissions = [Permission.STATISTIC_NAV];

export default Page;
